import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Flat contract (docs/design/frontend-form-controls.md): a closed field carries
          // no box shadow, and disabled changes the fill only — disabled:opacity-* fades
          // border, text and placeholder together, which makes an empty disabled field
          // hard to tell from a filled one.
          //
          // The disabled fill is ink-3/15, NOT the client's muted/15: admin maps --muted
          // to a near-white surface, so a muted wash renders near #fdfdfd over a white
          // field and is invisible. ink-3 holds the client's --muted values, so this
          // reproduces the contract's intended wash in both themes.
          //
          // The alpha is /15 (#e8e9ea light, #252529 dark), never /30. At /30 the fill
          // lands on #d2d2d5 — darker than border-input (--hairline #e6e6e9) — and in
          // dark mode on #37373c, lighter than --hairline-strong. Either way the fill
          // swallows the control's own outline and the field reads as a grey slab
          // instead of an inactive field.
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-placeholder focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:bg-ink-3/15 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
